import type { ComponentPropsWithoutRef } from 'react';

import device from '../../utils/device';
import useIsAfterHydration from '../../hooks/use-is-after-hydration';
import useViewportValue from '../../utils/use-viewport-value';
import type { Breakpoint } from '../../utils/device';

const allBreakpoints: readonly Breakpoint[] = ['xs', 'sm', 'md', 'lg'];

export type ResponsiveVideoProps = ComponentPropsWithoutRef<'video'> & {
  renderOn?: readonly Breakpoint[];
};

const ResponsiveVideo = ({ children, renderOn = allBreakpoints, ...videoProps }: ResponsiveVideoProps) => {
  const breakpoint = useViewportValue(device.getBreakpoint);
  const isAfterHydration = useIsAfterHydration();
  const showVideo = isAfterHydration && renderOn.includes(breakpoint);

  if (!showVideo) {
    return null;
  }

  return (
    <video muted {...videoProps}>
      {children}
    </video>
  );
};

export default ResponsiveVideo;
